import React, { useEffect, useState } from "react";
import { getNewMovies, getPhimLe, getPhimBo, getPhimHoatHinh, TvShow } from "../api/movieApi";
import MovieList from "../components/MovieList";
import MovieListOther from "../components/MovieListOther";
import "./../assets/styles/css/HomePage.css";
import { useNavigate } from "react-router-dom";
import { GrFormNext } from "react-icons/gr";
import { GrFormPrevious } from "react-icons/gr";
import MovieSlider from "../components/Slider/MovieSlider";
import WeakNetworkNotification from "../components/WeakNetworkNotification/WeakNetworkNotification";

const HomePage = () => {
  const [movies, setMovies] = useState([]);
  const [phimLe, setPhimLe] = useState([]);
  const [phimBo, setPhimBo] = useState([]);
  const [phimHoatHinh, setPhimHoatHinh] = useState([]);
  const [tvShows, setTvShows] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isNetworkWeak, setIsNetworkWeak] = useState(false);
  const navigate = useNavigate();
  const MAX_SAVE_DAYS = 7;

  const clearOldProgress = () => {
    const now = new Date().getTime();
    for (const key in localStorage) {
      if (key.startsWith("videoTime_")) {
        const data = JSON.parse(localStorage.getItem(key));
        if (data && data.timestamp) {
          const savedTime = data.timestamp;
          if (now - savedTime > MAX_SAVE_DAYS * 24 * 60 * 60 * 1000) {
            localStorage.removeItem(key);
            console.log(`Đã xóa tiến trình cũ: ${key}`);
          }
        }
      }
    }
  };

  const clearLocalStorage = () => {
    localStorage.removeItem("phim-le");
    localStorage.removeItem("phim-bo");
    localStorage.removeItem("phim-hoat-hinh");
    localStorage.removeItem("tv-shows");
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith("new-movies-page-")
    );
    keys.forEach((key) => localStorage.removeItem(key));
  };

  useEffect(() => {
    if (window.location.pathname === "/") {
      clearLocalStorage();
    }
  }, []);

  useEffect(() => {
    const handlePageHide = () => {
      clearLocalStorage();
    };

    window.addEventListener("pagehide", handlePageHide);
    return () => window.removeEventListener("pagehide", handlePageHide);
  }, []);

  useEffect(() => {
    const checkNetworkStatus = () => {
      setIsNetworkWeak(!navigator.onLine); 
    };
  
    window.addEventListener("offline", checkNetworkStatus);
    window.addEventListener("online", checkNetworkStatus);
    checkNetworkStatus();
  
    return () => {
      window.removeEventListener("offline", checkNetworkStatus);
      window.removeEventListener("online", checkNetworkStatus);
    };
  }, []);
  
  const fetchAndStore = async (key, fetchFunction, setter) => {
    const storedData = JSON.parse(localStorage.getItem(key));

    if (storedData) {
      setter(storedData);
    } else {
      const response = await fetchFunction();
      const items = response?.data?.data?.items || [];
      setter(items);
      localStorage.setItem(key, JSON.stringify(items));
    }
  };

  useEffect(() => {
    clearOldProgress();
    
    const fetchMovies = async () => {
      setLoading(true);
      try {
        const newMoviesKey = `new-movies-page-${page}`;
        const newMoviesStored = JSON.parse(localStorage.getItem(newMoviesKey));
        if (newMoviesStored) {
          setMovies(newMoviesStored);
        } else {
          const response = await getNewMovies(page);
          const items = response?.data?.items || [];
          setMovies(items);
          localStorage.setItem(newMoviesKey, JSON.stringify(items));
        }

        await Promise.all([
          fetchAndStore("phim-le", getPhimLe, setPhimLe),
          fetchAndStore("phim-bo", getPhimBo, setPhimBo),
          fetchAndStore("phim-hoat-hinh", getPhimHoatHinh, setPhimHoatHinh),
          fetchAndStore("tv-shows", TvShow, setTvShows),
        ]);
      } catch (error) {
        console.error("Lỗi khi gọi API:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchMovies();
  }, [page]);

  const handleNextPage = () => setPage((prev) => prev + 1);
  const handlePrevPage = () => setPage((prev) => (prev > 1 ? prev - 1 : 1));

  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <div className="home-page">
      {isNetworkWeak ? (
        <WeakNetworkNotification
          onRetry={() => {
            if (navigator.onLine) {
              setIsNetworkWeak(false);
            }
          }}
        />
      ) : (
        <>
          <MovieSlider />
          <div className="group-movies-section">
            <section className="movies-section">
              <div className="section-title-lv0">
                <h2 className="section-title-lv1">Phim Mới Cập Nhật</h2>
                <div className="pagination-controls">
                  <button onClick={handlePrevPage} disabled={page === 1}>
                    <GrFormPrevious/>
                  </button>
                  <span className="page-number">{page}</span>
                  <button onClick={handleNextPage}><GrFormNext/></button>
                </div>
              </div>
              <MovieList movies={movies} loading={loading} />
            </section>
  
            <section 
            className="movies-section">
              <h2 className="section-title"
                onClick={() => handleNavigate("/phim-le")}
                style={{ cursor: "pointer" }}>Phim Lẻ <GrFormNext /></h2>
              <MovieListOther movies={phimLe} loading={loading} />
            </section>
  
            <section 
            className="movies-section">
              <h2 className="section-title"
                onClick={() => handleNavigate("/phim-bo")}
                style={{ cursor: "pointer" }}>Phim Bộ <GrFormNext /></h2>
              <MovieListOther movies={phimBo} loading={loading} />
            </section>
  
            <section 
            className="movies-section">
              <h2 className="section-title"
                onClick={() => handleNavigate("/hoat-hinh")}
                style={{ cursor: "pointer" }}>Phim Hoạt Hình <GrFormNext /></h2>
              <MovieListOther movies={phimHoatHinh} loading={loading} />
            </section>
  
            <section 
            className="movies-section">
              <h2 className="section-title"
                onClick={() => handleNavigate("/tv-shows")}
                style={{ cursor: "pointer" }}>TV Shows <GrFormNext /></h2>
              <MovieListOther movies={tvShows} loading={loading} />
            </section>
          </div>
        </>
      )}
    </div>
  );  
};

export default HomePage;
